export default "__VITE_ASSET__12TbXBad__"